import {ConversationModel} from '../../../models/api/conversationModel';
import {TeammateModel} from '../../../models/api/teammateModel';

/*
 * Constants.
 */

// Based on @evonck's "really scientific measurement that is my gut feeling."
export const MAX_NUMBER_OF_CONVERSATIONS_PER_REQUEST = 50;

/*
 * Helpers.
 */

interface VisualConversationTrackerLike {
  teammate: TeammateModel;
  hasMuted: boolean;
}

export function computeShouldShowTrackers(
  conversation: ConversationModel,
  trackers: ReadonlyArray<VisualConversationTrackerLike>,
  options: {shouldHideAssignee?: boolean} = {},
): boolean {
  const trackersCount = trackers.length;
  const subscribersCount = trackers.filter((tracker) => !tracker.hasMuted).length;

  // If no trackers, nothing to do.
  if (trackersCount === 0) {
    return false;
  }

  // If we have only one subscriber AND it's the assignee, maybe hide the trackers.
  if (subscribersCount === 1 && trackers[0].teammate.id === conversation.assigneeId) {
    return !options.shouldHideAssignee;
  }

  // Show them!
  return true;
}

export function computeSubscriberCount(trackers: ReadonlyArray<VisualConversationTrackerLike>) {
  return trackers.filter((tracker) => !tracker.hasMuted).length;
}
